/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Ex_IntroInputs */

const en_to_typescript_ex_intro = /** @type {(inputs: To_Typescript_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two records where the second omits a key. That omission is what makes the field optional.`)
};

const ko_to_typescript_ex_intro = /** @type {(inputs: To_Typescript_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`두 번째가 키 하나를 생략한 두 개의 레코드입니다. 그 생략이 필드를 선택적으로 만듭니다.`)
};

const ja_to_typescript_ex_intro = /** @type {(inputs: To_Typescript_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 つ目がキーを 1 つ省いた 2 件のレコードです。その省略がフィールドを任意にします。`)
};

/**
* | output |
* | --- |
* | "Two records where the second omits a key. That omission is what makes the field optional." |
*
* @param {To_Typescript_Ex_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_ex_intro = /** @type {((inputs?: To_Typescript_Ex_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Ex_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_ex_intro(inputs)
	if (locale === "ko") return ko_to_typescript_ex_intro(inputs)
	return ja_to_typescript_ex_intro(inputs)
});